/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Composer = Loadable(lazy(() => import("./index")));

const composerRoutes = [
    {
        path: "composer",
        element: <Composer />,
    },
    {
        path: "composer/:webid",
        element: <Composer />,
    },
];

export { composerRoutes };
